// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', {setPrototypeOf: require('./_set-proto').set});


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/~/core-js/modules/es6.object.set-prototype-of.js
// module id = ../../../../core-js/modules/es6.object.set-prototype-of.js
// module chunks = 3